import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { useTranslation } from 'next-i18next';
import RedirectIcon from '../../../public/img/icons/icon_redirect.svg';

interface PreviousVersionProps {
  name: string;
  date: string;
  moreLink: string;
  supText?: string;
  downloadLink: string;
}
const PreviousVersion: React.FC<PreviousVersionProps> = ({
  name,
  date,
  moreLink,
  supText,
  downloadLink,
}) => {
  const { t } = useTranslation();
  const router = useRouter();
  const downloadText = `${t('previous-versions_download')} ${name}`;

  return (
    <div className="previous-version-item">
      <h3 className="item-title">
        {name}
        {supText ? <sup className="item-sup">{supText}</sup> : ''}
      </h3>
      <p className="item-date">{date}</p>
      <div className="item-links">
        <a
          href={downloadLink}
          onClick={(e) => {
            e.preventDefault();
            window.open(downloadLink, '_blank');
            router.push('/terminal/how-to-setup');
          }}
        >
          {downloadText}
        </a>
        <Link passHref href={moreLink}>
          <a target="_blank">
            {t('previous-versions_more-about-version')}{' '}
            <RedirectIcon className="foot-redirect-icon" />
          </a>
        </Link>
      </div>
    </div>
  );
};

export default PreviousVersion;
